$(function () {

    // ������� ���������� �� ������� ��������
    var PbSlider = null;
    initPhSlider();

    function initPhSlider() {

        var colWidth = 302;
        var maxSlides = Math.floor($('.index-page-photoblocks').innerWidth() / colWidth);

        PbSlider = $('.index-page-photoblocks .tgb-list').bxSlider({
            auto: window.location.hash.substr(1).indexOf('place_id_') === -1,
            adaptiveHeight: false,
            pager: true,
            controls: true,
            autoHover: true,
            minSlides: 1,
            maxSlides: maxSlides,
            slideWidth: colWidth,
            slideMargin: 16,
            touchEnabled: true
        });
    }

    // ��� ������� ������������������ �������.
    // ��� ���������� ������� ����� ������ � ���������
    var sliderResizeTimer;
    var setSlider = function () {
        clearTimeout(sliderResizeTimer);
        sliderResizeTimer = setTimeout(function () {
            initPhSlider();
        }, 500);
    };
    $(window).bind('resize', function () {
        setSlider();
    });

    // ������� ����� ��� �����-�������� �� ������
    $('#animated-background').find('div').each(function () {
        var css = {
            backgroundImage: 'url(' + $(this).data('bg') + ')'
        };
        var bgposition = $(this).data('bgposition');
        if (bgposition) {
            css['background-position'] = bgposition;
        }
        $(this).css(css);
    });
    setInterval(changePromoBg, 10000);

    function changePromoBg() {
        $('#animated-background').find('div').first().css('opacity', 0).appendTo('#animated-background').animate({
            opacity: 1
        }, 3000);
    }


    // �������� ��� �������� ��������� ��������
    $('.appear-box').each(function () {
        if (!$.inViewport(this)) {
            $(this).find('.appear-block').css({opacity: 0});
        }
    });

    $(window).on('scroll', function () {
        $('.appear-box').each(function () {
            if ($.inViewport(this)) {
                var time = 200;
                $('.appear-block', this).each(function () {
                    var block = $(this);
                    setTimeout(function () {
                        block.css({opacity: 1});
                    }, time);
                    time += 200;
                });
            }
        });
    });
});

